<template>
  <div
    class="header-part"
    :class="{
      'header-search search text-center': variant !== 'navbar',
      'text-center h-full w-full': isNavbarVariant,
    }"
    v-if="!isDuplicate && productListLoaded"
  >
    <div
      v-if="!hideSearchProducts || true"
      class="header-search-inner inline-block"
      :class="{
        'h-full w-full nav-2024-overrides': isNavbarVariant,
      }"
    >
      <div
        class="header-search-main"
        :class="{
          'h-full w-full': isNavbarVariant,
        }"
      >
        <div
          class="input-group has-feedback"
          :class="{
            'h-full w-full': isNavbarVariant,
          }"
        >
          <div
            :class="{
              'h-full w-full': isNavbarVariant,
            }"
            style="position: relative"
          >
            <input
              type="text"
              id="tipue_drop_input"
              autocomplete="off"
              class="form-control"
              :placeholder="isNavbarVariant ? 'Search treatments...' : 'Search products...'"
              :value="searchQuery"
              @input="(e) => (this.searchQuery = e.target.value)"
            />
            <SearchIcon2024 v-if="isNavbarVariant" class="h-full absolute right-[16px] text-[#767676]" />
            <div v-else class="glyphicon glyphicon-search form-control-feedback search-icon"></div>
            <div id="tipue_drop_content" v-if="noSearchResultsFound">
              <div class="tipue_drop_no-results">No result found</div>
            </div>
            <div id="tipue_drop_content" v-if="searchResults.length">
              <div class="dropdown-selector">
                <div class="tipue_drop_wrapper">
                  <div v-for="(categoryProducts, categoryLoc, idx) in searchResultsByCategory" :key="idx">
                    <a
                      v-for="(product, key) in categoryProducts"
                      :key="key"
                      :href="product.isOTC ? product.loc : product.categoryLoc"
                      @click="fireClickedProductEvent(product)"
                      class="tipue_drop_item"
                      rel="nofollow"
                    >
                      <div class="tipue_drop_left">
                        <img
                          :src="product.thumb"
                          class="tipue_drop_image"
                          width="60"
                          height="60"
                          :alt="product.title"
                        />
                      </div>
                      <div class="tipue_drop_right">
                        <div class="tipue_drop_right_title" v-html="highlightSearchQuery(product.title)" />
                        <div class="tipue_drop_right_text" v-html="highlightSearchQuery(product.text)" />
                      </div>
                    </a>

                    <a
                      :href="categoryLoc"
                      @click="fireClickedCategoryEvent(categoryProducts[0].text)"
                      class="tipue_drop_cat-item"
                      rel="nofollow"
                      v-if="categoryLoc !== 'NONE'"
                    >
                      in <strong>{{ categoryProducts[0].text }}</strong>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Fuse from "fuse.js";
import { getSearchableProducts } from "../MedExpressJS/Products";
import SearchIcon2024 from "../../resources/search.svg?inline";

import { amplitudeEvent } from "../MXPixel/MedexpressAmplitude";

export default Vue.extend({
  components: {
    SearchIcon2024,
  },
  props: {
    variant: undefined,
  },
  data() {
    return {
      productListLoaded: false,
      searchQuery: "",
      isDuplicate: window.isDuplicate,
      hideSearchProducts: window.hideSearchProducts,
      searchEventLogTimeout: null,
      mobileSearchOpen: false,
      fuse: null,
    };
  },
  created() {
    getSearchableProducts().then((products) => {
      this.fuse = new Fuse(products, {
        shouldSort: true,
        includeScore: true,
        keys: [{ name: "title", weight: 2 }, "text", "tags"],
      });
      this.productListLoaded = true;
    });
  },
  mounted() {
    const mobileSearchTrigger = document.getElementById("search-mobile-trigger");
    if (mobileSearchTrigger) {
      mobileSearchTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        mobileSearchTrigger.classList.toggle("search-container-open");
        this.mobileSearchOpen = !this.mobileSearchOpen;
      });
    }
  },
  computed: {
    searchResults() {
      const search = this.fuse.search(this.searchQuery);
      return search
        .filter((result) => result.score < 0.3)
        .map((result) => ({
          ...result.item,
          score: result.score,
        }))
        .slice(0, 10);
    },
    searchResultsByCategory() {
      if (this.searchResults.length === 0) {
        return {};
      }

      const productByCategory = {};
      this.searchResults.forEach(function (product) {
        const categoryIdentifier = product.categoryLoc || "NONE";
        productByCategory[categoryIdentifier] = productByCategory[categoryIdentifier] || [];
        productByCategory[categoryIdentifier].push(product);
      });
      return productByCategory;
    },
    noSearchResultsFound() {
      return this.searchResults.length === 0 && this.searchQuery.length > 1;
    },
    isNavbarVariant() {
      return this.variant === "navbar";
    },
  },
  methods: {
    highlightSearchQuery(title) {
      const lowerCaseQuery = this.searchQuery.trim().toLowerCase();
      const lowerCaseTitle = title.toLowerCase();
      const matchStartingIndex = lowerCaseTitle.indexOf(lowerCaseQuery);
      const matchEndingIndex = matchStartingIndex + lowerCaseQuery.length;

      if (matchStartingIndex === -1) {
        return title;
      }

      return (
        title.substring(0, matchStartingIndex) +
        "<strong>" +
        title.substring(matchStartingIndex, matchEndingIndex) +
        "</strong>" +
        title.substring(matchEndingIndex)
      );
    },
    fireClickedProductEvent(searchItem = {}) {
      amplitudeEvent("Clicked Search Result", {
        Title: searchItem.title,
        Type: searchItem.isOTC ? "OTC" : "RX",
      });
    },
    fireClickedCategoryEvent(categoryName) {
      amplitudeEvent("Clicked Search Result", {
        Title: categoryName,
        Type: "CATEGORY",
      });
    },
  },
  watch: {
    searchQuery(newValue) {
      if (this.searchEventLogTimeout) {
        clearTimeout(this.searchEventLogTimeout);
      }
      this.searchEventLogTimeout = setTimeout(() => {
        if (newValue) {
          amplitudeEvent("Search For Item", {
            NumberOfResults: this.searchResults.length,
            Query: newValue,
          });
        }
      }, 1000);
    },
  },
});
</script>

<style scoped>
.nav-2024-overrides {
  width: 100%;
  min-width: auto;
  max-width: none;
}

.nav-2024-overrides input {
  height: 100% !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  color: #013f82 !important;
}

.nav-2024-overrides input::placeholder {
  font-size: 16px;
  color: #767676 !important;
}
</style>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
